<template>
  <div class="lp-float-logo">
    <img src="@/assets/img/lp-logo-black.svg" alt="LoanPro Logo">
  </div>
</template>

<script></script>

<style>
.lp-float-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 140px;
  height: auto;
  z-index: 9999;
}

.lp-float-logo img {
  width: 100%;
  height: auto;
}
</style>
